var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.093 2.789.789-.774c.398-.398.414-.828.062-1.187L12.68.562c-.352-.351-.781-.312-1.18.07l-.789.782zm-9.211 9.187 8.523-8.515-1.367-1.375-8.531 8.523-.742 1.734c-.07.188.125.407.312.328z"
  })));
};
export default SvgEdit;